import Icon from '../components/Icon.vue'

Icon.register({
  'sign-language': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M91.4 484C91.1 468 104.5 454.9 120.6 454.9H182.9V449.1H57C41 449.1 27.6 436 27.9 420 28.2 404.5 40.8 392 56.4 392H182.9V386.3H29.1C13.1 386.3-0.3 373.2 0 357.2 0.3 341.6 13 329.1 28.6 329.1H182.9V323.4H57.7C41.7 323.4 28.3 310.3 28.6 294.3 28.9 278.8 41.5 266.3 57.1 266.3H225.7L194.6 243.7C181.9 234.4 179 216.5 188.3 203.8 197.6 191 215.5 188.2 228.2 197.5L351.6 287.2A34.3-34.3 0 0 0 365.7 314.9V456C365.7 472 354.8 485.8 339.3 489.4L258.8 508.4A137.2-137.2 0 0 0 227.4 512H120C104.4 512 91.7 499.5 91.4 484zM164.7 258.3H201.1L189.9 250.2C171.3 236.6 169.6 209.3 186.7 193.6L173.7 176.9C163.9 164.3 145.3 161.7 132.9 171.8 120.8 181.6 118.7 199.3 128.3 211.6L164.7 258.3zM448 256.2L443 103.7C442.5 88 429.3 75.6 413.5 76.1 397.7 76.6 385.3 89.8 385.9 105.6L387.1 144 283.6 11C274-1.3 256.3-3.6 243.9 5.7 231.1 15.3 229 33.9 238.8 46.6L315.7 145.3 311.2 148.8 216.4 27.1C206.8 14.8 189.2 12.5 176.8 21.8 163.9 31.4 161.8 50 171.7 62.6L266.1 183.9 261.6 187.4 183.9 87.7C174.4 75.4 156.7 73.1 144.3 82.4 131.5 92 129.4 110.6 139.2 123.2L191.2 190.1C203.7 181.8 220.3 181.8 232.9 191L356.3 280.7C367.2 288.6 373.7 301.4 373.7 314.9V331.9L434.8 284.4A34.3-34.3 0 0 1 448 256.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sign-language.js
// module id = 4+yi
// module chunks = 144